import { getCookie } from "../../api/apiClient";

export const getUserInfo = () => {
  return JSON.parse(getCookie("user_data") || "{}");
};

export const isUserAllowed = () => {
  const userInfo = getUserInfo();
  return userInfo.access_enabled === true;
};
